import React, {Fragment} from 'react';
import Box from '../../layout/Box';
import StoreOrderForm from '../forms/BooklogStoreOrderForm';
import StoreOrderList from './../lists/BooklogStoreOrderList';
import BoxEditor from "./../BoxEditor";
import Button from "../../form/Button";
import {postData} from "../../../utils/request";
import createEditor from "../../form/ComponentEditor";
import {connect} from "src/store";
import get from "../../../utils/get";
import Confirm from "../../form/Confirm";
import {list} from "../../../utils/array";
import {fieldFilter} from "../../../utils/components";
import StateMachine from "../../form/StateMachine";
import TextInput from "../../form/TextInput";

export const orderTypes = {
    SALES_ORDER:  ordertype => ordertype + "" === "0",
    PURCHASE_ORDER: ordertype => ordertype + "" === "1",
};

export class StoreOrderEditorComponent extends React.Component {

    state = {
        all: true,
        bulkComplete: [],
        modificationItems: {},
        split: 2,
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    saveForm = async (data) => {
        await this.props.saveForm(data);
        this.editor && this.editor.refresh();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    getFieldProps = (name) => {
        let props = {...this.props.getFieldProps(name)};
        props = {...props};
        props.disabled = props.disabled || this.props.stateType.Completed(this.props.values.state, ">");
        if (name === "pickedqty") {
            props.disabled = props.disabled || (this.props.values.ordertype !== undefined
                &&
                this.props.values.serviceprovider_type !== "internal_store");
        }
        return props;
    }

    orderCompleted = async (all = null) => {
        if (all) {
            await this.props.processAction(async () => {
                await Promise.all(all.map(async (id) => {
                    await postData({
                        action: this.props.componentConfig.componentname + '.orderCompleted',
                        [this.props.componentConfig.idfield]: id
                    });
                }));
            });
            this.list && this.list.refreshBackground();
            this.form && this.form.refreshBackground();
        } else {
            const values = this.props.values;
            await this.props.processAction(async () => {
                const response = await postData({
                    action: this.props.componentConfig.componentname + '.orderCompleted',
                    [this.props.componentConfig.idfield]: values[this.props.componentConfig.idfield]
                });
                if (response.success) {
                    this.list && this.list.refreshBackground();
                    this.form && this.form.refreshBackground();
                }
                return response;
            });
        }
    }

    checkOrder = async () => {
        const values = this.props.values;
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.checkOrder',
                [this.props.componentConfig.idfield]: values[this.props.componentConfig.idfield]
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
            }
            return response;
        });
    }

    deleteFrom = async () => {
        const values = this.props.values;
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.deleteFrom',
                [this.props.componentConfig.idfield]: values[this.props.componentConfig.idfield],
                view: this.props.view
            });
            if (response.success) {
                this.list && this.list.refreshBackground && this.list.refreshBackground();
                this.form && this.form.refreshBackground && this.form.refreshBackground();
            }
            return response;
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.values[prevProps.componentConfig.idfield] !== this.props.values[this.props.componentConfig.idfield]) {
            this.setState({modificationItems: {}});
        }
    }

    render() {
        const splitAble = this.props.values[this.props.componentConfig.idfield]
            &&
            !this.props.values.booklog_id
            &&
            orderTypes.PURCHASE_ORDER(this.props.values.ordertype)
            &&
            get(this, "props.context.partner.partner_id") + "" !== "" + get(this, "props.values.partner.partner_id");
        const clientFields = this.props.damaged === undefined && this.props.in === undefined && this.props.out === undefined && this.props.values.client_component && (!this.props.client || !(this.props.client && this.props.client.values[this.props.client.componentConfig.idfield] + "" === "" + this.props.values.client_component_id));
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const props = {...this.props};
        props.listFilter = list(props.listFilter);
        if (props.in) {
            props.listFilter.push({
                field: "ordertype",
                value: 1
            });
        } else if (props.out) {
            props.listFilter.push({
                field: "ordertype",
                value: 0
            });
        } else if (props.damaged) {
            props.listFilter.push({
                field: "ordertype",
                value: 0
            });
            props.listFilter.push({
                field: "booklog_id",
                value: "K257",
                matchmode: "any",
                operator: "LIKE",
            })
        }
        if (!this.props.user.hasPermission("all_storeorders") || !this.state.all) {
            props.listFilter.push({
                field: "partner",
                value: get(this.props.context, "client.partner_id")
            })
        }
        const actionButtons = [
            <Button
                key="1"
                disabled={!this.props.values[this.props.componentConfig.idfield]}
                color="danger"
                className="pull-left"
                onClick={this.props.deleteForm}
            >
                Törlés
            </Button>,
            <Button
                key="2"
                disabled={!this.props.dirty || this.props.isLoading}
                color="primary"
                className="pull-right"
                onClick={this.saveForm}
            >
                Mentés
            </Button>
        ];
        const listButtons = [];
        if (this.props.user.hasPermission("all_storeorders") && this.props.parent === undefined) {
            listButtons.push(
                <Button
                    key="10"
                    disabled={!this.state.bulkComplete.length}
                    color="danger"
                    className="pull-right"
                    onClick={async () => {try {await this.orderCompleted(this.state.bulkComplete);} catch (e) {} this.setState({bulkComplete: []});}}
                >
                    Tömeges lezárás
                </Button>
            );
        }
        if (this.props.stateType.Picking(this.props.values.state)) {
            actionButtons.push(
                <Button
                    key="15"
                    color="default"
                    className="pull-right"
                    onClick={this.checkOrder}
                >
                    Állapot lekérdezés
                </Button>
            )
        }
        if (this.props.stateType.Modification(this.props.values.state)) {
            actionButtons.push(
                <Confirm
                    header="Biztos?"
                    body="Biztos módosítod a tételeket?"
                    key="20"
                    disabled={this.props.disabled || this.props.isLoading || this.state.isLoading || !Object.keys(this.state.modificationItems).length}
                    color="primary"
                    className="pull-right"
                    onAccept={async () => await this.props.processAction(async ({componentAction}) => {
                        await componentAction("proceedState", {items: this.state.modificationItems});
                        this.setState({modificationItems: {}});
                    })}
                >
                    Módosítás
                </Confirm>
            );
            actionButtons.push(
                <Confirm
                    header="Biztos?"
                    body="Biztos lezárod?"
                    key="21"
                    disabled={this.props.disabled || this.props.isLoading || this.state.isLoading || Object.keys(this.state.modificationItems).length}
                    color="primary"
                    className="pull-right"
                    onAccept={async () => await this.props.processAction(async ({componentAction}) => await componentAction("proceedState", {checked: true}))}
                >
                    Mehet
                </Confirm>
            );
        }
        if (this.props.user.hasPermission("all_storeorders")) {
            if (
                this.props.values[this.props.componentConfig.idfield]
                &&
                (
                    (
                        !this.props.values.booklog_id
                        &&
                        this.props.stateType.Received(this.props.values.state)
                    )
                    ||
                    (
                        this.props.user.hasPermission("all_storeorders")
                        &&
                        (
                            this.props.stateType.Revision(this.props.values.state)
                            ||
                            this.props.stateType.Picking(this.props.values.state)
                            ||
                            this.props.stateType.StockMismatchNotification(this.props.values.state)
                            ||
                            this.props.stateType.MismatchNotification(this.props.values.state)
                            ||
                            this.props.stateType.SettledNotification(this.props.values.state)
                            ||
                            this.props.stateType.RevisionNotification(this.props.values.state)
                        )
                    )
                )
            ) {
                actionButtons.push(
                    <Button
                        key="70"
                        color="primary"
                        disabled={this.props.disabled || this.props.isLoading || this.state.isLoading}
                        className="pull-right"
                        onClick={async () => await this.props.processAction(async ({componentAction}) => await componentAction("proceedState", {proceed: this.props.stateType.Received(this.props.values.state, "<=")}))}
                    >
                        {!this.props.values.booklog_id && this.props.stateType.Received(this.props.values.state) ? "Újra küldés" : "Mehet"}
                    </Button>
                );
            }
            if (splitAble && this.props.stateType.Received(this.props.values.state)) {
                actionButtons.push(
                    <Confirm
                        key="90"
                        color="default"
                        disabled={this.props.disabled || this.props.isLoading || this.state.isLoading}
                        className="pull-right"
                        header="Hány részre osztod?"
                        body={<div className="row form-row">
                            <div className="col-md-12">
                                <div className="form-group">
                                    <TextInput
                                        label={false}
                                        value={this.state.split}
                                        saveChanges={(field, split) => this.setState({split})}
                                    />
                                </div>
                            </div>
                        </div>}
                        acceptAble={!!parseInt(this.state.split)}
                        onAccept={async () => await this.props.processAction(async ({componentAction}) => await componentAction("proceedState", {split: this.state.split}))}
                    >
                        Részekre bontás
                    </Confirm>
                );
            }
            actionButtons.push(
                <Confirm
                    key="5"
                    onAccept={async () => {
                        try {
                            await this.deleteFrom();
                            if (this.props.reloadForm) {
                                await this.props.reloadForm();
                            }
                        } catch (e) {

                        }
                    }}
                    color="danger"
                    header="Törlés"
                    className="pull-left"
                    body="Biztos törlöd ezt a tételt?"
                >
                    Törlés a Pharmalog-ból
                </Confirm>
            );
        }
        return (
            <Fragment>
                <List
                    {...props}
                    theme="default"
                    header={
                        props.componentEditor === "BooklogStoreOrderIn" || props.in
                        ?
                            "Bevételezés rendelések"
                        :
                            (props.componentEditor === "BooklogStoreOrderOut" || props.out
                            ?
                                "Kiszedés rendelések"
                            :
                                (props.componentEditor === "UnknownStoreOrder" || props.unknown
                                ?
                                    "Ismeretlen bevétek"
                                :
                                    "Raktári rendelések"
                                )
                            )
                    }
                    footer={listButtons}
                >
                    <StoreOrderList
                        ref={(el) => this.list = el}
                        {...props}
                        clientFields={clientFields}
                        loadForm={this.loadForm}
                        orderTypes={orderTypes}
                        stateType={this.props.stateType}
                        all={this.state.all}
                        setAll={(all) => this.setState({all})}
                        bulkComplete={this.state.bulkComplete}
                        setBulkComplete={(bulkComplete) => this.setState({bulkComplete})}
                    />
                </List>
                {this.props.values[this.props.componentConfig.idfield] && <Editor
                    {...props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header={"Raktári rendelés adatai"}
                    footer={actionButtons}
                >
                    <StoreOrderForm
                        ref={(form) => this.form = form}
                        {...props}
                        splitAble={splitAble}
                        modificationItems={this.state.modificationItems}
                        setModificationItems={(modificationItems) => this.setState({modificationItems})}
                        clientFields={clientFields}
                        orderTypes={orderTypes}
                        stateType={this.props.stateType}
                        getFieldProps={this.getFieldProps}
                    />
                </Editor>}
            </Fragment>
        );
    }
}

const StoreOrderStateMachine = (props) => {
    return <StateMachine {...props} stateOption={props.componentConfig?.fielddefs?.state?.optionname ?? "BooklogStoreOrder_state"}>
        {props.children}
    </StateMachine>;
}

const StoreOrderStateMachineEditor = (props) => {
    return <StoreOrderStateMachine {...props}>
        <StoreOrderEditorComponent />
    </StoreOrderStateMachine>;
}

const BooklogStoreOrderEditor = connect((state) => {
    return {
        user: state.app.user,
        context: state.app.context
    }
})(createEditor({
    componentName: "BooklogStoreOrder",
    WrappedComponent: StoreOrderStateMachineEditor,
    props: {
        view: "admin",
        componentActions: (action, data, params) => {
            data = {...data};
            delete data.client;
            return {action,data,params};
        }
    }
}));

export default BooklogStoreOrderEditor;

export const StoreOrderClaimsFilter = (props) => {
    props = {...props};
    props.listFilter = list(props.listFilter, fieldFilter("state", [props.stateConst.Revision, props.stateConst.RevisionProcessed, props.stateConst.RevisionNotification, props.stateConst.Processed, props.stateConst.Modification], "in"));
    return <BooklogStoreOrderEditor {...props} editorContext="StoreOrderClaims" claim={true} />;
}

export const StoreOrderClaims = (props) => {
    return <StoreOrderStateMachine {...props}>
        <StoreOrderClaimsFilter />
    </StoreOrderStateMachine>
}

export const StoreOrderClaim = () => null;